// Kleines Strichsymbol vor jedem Kommissionier-Auftrag: Palette (beladen, Bretter auf Kloetzen)
// oder Karton (Kiste mit Klebeband) — man sieht die Auftragsart ohne zu lesen.
export function AuftragSymbol({ art }: { art: 'palette' | 'karton' }) {
  const palette = art === 'palette'
  return (
    <svg role="img" aria-label={palette ? 'Palette' : 'Karton'} viewBox="0 0 32 32" width="28" height="28"
      className={`shrink-0 ${palette ? 'text-muted' : 'text-primary'}`}
      fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round">
      {palette ? (
        <>
          <path d="M5 4h22v11H5zM5 9.5h22M16 4v11" />
          <path d="M3 15h26v3H3z" />
          <path d="M4.5 18h4.5v4H4.5zM13.75 18h4.5v4h-4.5zM23 18h4.5v4H23z" />
          <path d="M3 22h26v3H3z" />
        </>
      ) : (
        <>
          <path d="M4 10l12-5 12 5v13l-12 5-12-5z" />
          <path d="M4 10l12 5 12-5M16 15v13" />
          <path d="M10 7.5l12 5v4" />
        </>
      )}
    </svg>
  )
}
